import axios from 'axios';

function gralTicket(data) {
    return axios.post('dashboard/gral/ticket', data);
}

function gralConsulta(data) {
    return axios.post('dashboard/gral/consulta', data);
}

function gralPreServicio(data) {
    return axios.post('dashboard/gral/pre-servicio', data);
}

const DashboardService = {
    gralTicket,
    gralConsulta,
    gralPreServicio
};
export default DashboardService;
